var React = require('react');

function TriangleHeaderTiny (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M51.8281 43.9997L15.7081 53.0915L38.9613 -0.000119159L51.8281 43.9997Z","fill":"#6C21E4","key":0}),React.createElement("path",{"d":"M77.2883 71.4919L15.665 53.0463L51.7447 43.983L77.2883 71.4919Z","fill":"#651DD8","key":1}),React.createElement("path",{"d":"M77.2891 71.4912L51.7634 44.0017L38.962 0.00044174L77.2891 71.4912Z","fill":"#5915C7","key":2})]);
}

TriangleHeaderTiny.defaultProps = {"width":"93","height":"94","viewBox":"0 0 93 94","fill":"none"};

module.exports = TriangleHeaderTiny;

TriangleHeaderTiny.default = TriangleHeaderTiny;
